import React from 'react';
import './Home.css';
import img1 from './img1.png';
import Slide from 'react-reveal/Slide';


function Home() {
    return (
        <div>
            <div className='home-section'>
                <Slide right>
                    <div className='image'>
                        <img className='img1' src={img1} />
                    </div>
                </Slide>
                <div className='slogan'>
                    <h1 className='text'>Make your dream apps and websites come True</h1>
                </div>
            </div>
        </div>
    )
}

export default Home
